"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericDataModel = void 0;
/* eslint-disable max-classes-per-file */
class DataModel {
}
exports.default = DataModel;
class GenericDataModel extends DataModel {
    constructor(data) {
        super();
        Object.assign(this, data);
    }
    get data() {
        return this;
    }
}
exports.GenericDataModel = GenericDataModel;
//# sourceMappingURL=DataModel.js.map